import { Flex } from "antd";
import dayjs from "dayjs";
import { ReactNode, useContext } from "react";

import BaseButton from "@/components/BaseButton";
import { MainContainer } from "@/components/Layout/Styled";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { AppIdentity } from "@/components/UI/AppIdentity";
import { SWContext } from "@/context/SWContext";
import { Maintenance } from "@/types";

import { StyledSettingOutlined } from "./Styles";

const checkMaintenance = (maintenance?: Maintenance) => {
    if (!maintenance?.enabled) return false;

    const now = dayjs().valueOf();
    const startsAt = maintenance.startsAt
        ? dayjs(maintenance.startsAt).valueOf()
        : null;
    const endsAt = maintenance.endsAt
        ? dayjs(maintenance.endsAt).valueOf()
        : null;

    if (startsAt && now < startsAt) return false;
    if (endsAt && now > endsAt) return false;

    return true;
};

export const MaintenanceBlocker = ({ children }: { children: ReactNode }) => {
    const { maintenance } = useContext(SWContext);

    const isMaintenanceActive = checkMaintenance(maintenance);

    if (isMaintenanceActive) {
        return (
            <MainContainer>
                <Flex
                    vertical
                    gap={32}
                    flex={1}
                    align="center"
                    justify="center"
                >
                    <AppIdentity logoHeight={180} />

                    <Flex vertical gap={16} align="center">
                        <Flex gap={8} align="center">
                            <StyledSettingOutlined />

                            <PrimaryText
                                fontSize={20}
                                fontWeight="600"
                                textAlign="center"
                            >
                                Технічні роботи
                            </PrimaryText>
                        </Flex>

                        <PrimaryText fontSize={15} textAlign="center">
                            {maintenance?.message ||
                                "Застосунок тимчасово недоступний через технічні роботи."}
                        </PrimaryText>

                        {maintenance?.endsAt && (
                            <SecondaryText textAlign="center">
                                Орієнтовно до:{" "}
                                {dayjs(maintenance?.endsAt).format("HH:mm")}
                            </SecondaryText>
                        )}
                    </Flex>

                    <BaseButton
                        type="primary"
                        onClick={() => window.location.reload()}
                    >
                        Оновити сторінку
                    </BaseButton>
                </Flex>
            </MainContainer>
        );
    }

    return <>{children}</>;
};
